// extracted by mini-css-extract-plugin
export default {"main":"hc_main__+uAKo"};